import type { Nullable } from '@iheartjane/types';

import type { CustomRow } from '@jane/bloom/types/schemas/roots/bloom/customRow';
import type { ProductSearchFilterCategory } from '@jane/bloom/viewModels/productSearchFilters';

// sort categories based on store custom product rankings
type GetCustomSortedCategories = {
  categories: ProductSearchFilterCategory[];
  productTypeRanking?: Nullable<string[]>;
};

export function getEnabledCustomRows(
  categories: ProductSearchFilterCategory[],
  customRows: CustomRow[]
) {
  if (customRows.length === 0) return categories;

  const customRowsByRowType = customRows.reduce<{ [key: string]: CustomRow }>(
    (rowTypes, customRow) => {
      rowTypes[customRow.row_type.toLowerCase()] = customRow;
      return rowTypes;
    },
    {}
  );

  return categories.filter((category) => {
    if (customRowsByRowType[category.value?.toLowerCase()])
      return customRowsByRowType[category.value.toLowerCase()].enabled;
    if (customRowsByRowType[category.label?.toLowerCase()])
      return customRowsByRowType[category.label.toLowerCase()].enabled;
    return true;
  });
}

export function getCustomSortedCategories({
  categories,
  productTypeRanking,
}: GetCustomSortedCategories) {
  const sortedCategories: ProductSearchFilterCategory[] = [];

  (productTypeRanking ?? []).forEach((rankedCategory) => {
    const foundCategory = categories.find(
      (category) =>
        category.value?.toLowerCase() === rankedCategory.toLowerCase() ||
        category.label?.toLowerCase() === rankedCategory.toLowerCase()
    );
    if (foundCategory) sortedCategories.push(foundCategory);
  });

  const remainingCategories = categories.filter(
    (category) => !sortedCategories.includes(category)
  );

  return [...sortedCategories, ...remainingCategories];
}
